<video id="player" autoplay class="video-js vjs-default-skin video-media" controls [class.large]="large">
  <source type="audio/mp3" [src]="src">
</video>